import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Text } from '@zillow/constellation';

var StyledCitation = /*#__PURE__*/styled(Text).withConfig({
  componentId: "sc-sf5s4v-0"
})(["font-style:italic;text-align:center;display:block;color:inherit;"]);
var BlockQuoteCitation = function BlockQuoteCitation(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(StyledCitation, {
    fontType: "h6",
    as: "cite"
  }, children);
};
BlockQuoteCitation.propTypes = process.env.NODE_ENV !== "production" ? {
  // Prefer string, but can pass anything. Non-string is used by editor.
  children: PropTypes.node.isRequired
} : {};
var BlockQuoteCitation$1 = BlockQuoteCitation;

export { BlockQuoteCitation$1 as default };
